import { Link } from 'react-router-dom';

export function Home() {
  return (
    <div className="page-home">
      <section className="hero">
        <h1>Integrella Benchmark</h1>
        <p className="lede">
          A technical assessment built around <strong>Wine</strong>, a tiny stack-based
          programming language. The Benchmark teaches you Wine and tests your
          understanding. Answer the questions carefully and thoughtfully as this test
          will be used to assess ability in the interview process.
        </p>
        <div className="cta-row">
          <Link to="/take" className="btn btn-primary">
            I have an access code
          </Link>
          <Link to="/admin" className="btn btn-secondary">
            Admin sign-in
          </Link>
        </div>
      </section>
      <section className="cards">
        <article className="card">
          <h2>🎯 The Benchmark</h2>
          <p>
            A timed multiple-choice assessment covering stack basics, arithmetic, strings,
            navigation, loops, and conditionals. Pass with <strong>50%</strong>.
          </p>
        </article>
        <article className="card">
          <h2>📈 Live progress</h2>
          <p>
            Track your scores, weakest categories, and badges from the candidate dashboard.
          </p>
        </article>
      </section>
    </div>
  );
}
